import { Spin, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Col, Row, Card, CardBody } from "reactstrap";
import { FiList } from "react-icons/fi";
import { FaQuestionCircle } from "react-icons/fa";
import { stringifySpecs } from "../../../firebase/utility";

const Step5Specifications = ({ newItem, setNewItem, specLoading }) => {
    return (
        <Card className="border-0 shadow-sm mb-4 bg-light">
            <CardBody className="p-4">
                <div className="d-flex align-items-center gap-2 mb-4 pb-2 border-bottom">
                    <div className="bg-primary-soft p-2 rounded-3 text-primary">
                        <FiList size={16} />
                    </div>
                    <h6 className="fw-bold text-dark mb-0 text-uppercase tracking-wider d-flex align-items-center" style={{ fontSize: '13px' }}>
                        Specifications 
                        <span className="ms-2 d-inline-flex align-items-center">
                            <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Enter each specification on a new line. You MUST separate the name and value with a colon (:). Example -> Color : Black">
                                <FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black', fontSize: '14px' }} />
                            </Tooltip>
                        </span>
                        <small className="text-lowercase fw-normal text-muted ms-2">(key : value)</small>
                    </h6>
                </div>
                <Row className="g-2">
            <Col md={12}>
                {specLoading ? (
                    <div className="d-flex justify-content-center align-items-center bg-white rounded" style={{ height: "300px", border: '1px solid #d9d9d9' }}>
                        <div className="text-center">
                            <Spin size="large" />
                            <p className="mt-2 text-muted fw-500">Loading Specifications...</p>
                        </div>
                    </div>
                ) : (
                    <TextArea
                        type={"Specification"}
                        label={"Title"}
                        placeholder={"key : Value\nkey : Value"}
                        size={"large"}
                        rows={12}
                        value={
                            typeof newItem?.item_specification === "object"
                                ? stringifySpecs(newItem?.item_specification)
                                : newItem?.item_specification
                        }
                        onChange={(e) =>
                            setNewItem({
                                ...newItem,
                                item_specification: e.target.value,
                            })
                        }
                    />
                )}
            </Col>
        </Row>
            </CardBody>
        </Card>
    );
};

export default Step5Specifications;
